import React, { useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { Image } from "antd";
import Common from "../components/includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
var EmployeeId = function EmployeeId() {
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /*#__PURE__*/_jsx(Image, {
            src: "/drawables/emgl.png",
            width: "150px"
          })
        })
      })
    })
  });
};
export default EmployeeId;